var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2858 21.4538C31.329 21.4561 30.5521 20.6812 30.5521 19.7244V13.5135H23.8486V29.1361H26.3571C26.6317 30.7558 28.0455 31.9959 29.742 31.9959C31.4386 31.9959 32.8523 30.7599 33.127 29.1361L37.5997 29.1188V21.4408L32.2858 21.4538ZM29.742 30.3802C28.7403 30.3802 27.9243 29.5642 27.9243 28.5625V28.5584V28.5423C27.9365 27.5526 28.7524 26.7448 29.742 26.7448C30.7317 26.7448 31.5476 27.5526 31.5598 28.5423V28.5625C31.5598 29.5642 30.7438 30.3802 29.742 30.3802Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9583 16.1081C34.136 14.8784 33.2144 14.5856 32.7153 14.6065L32.704 14.607H29.0706V13.5151H32.6821C33.6304 13.4804 34.8756 14.0265 35.8602 15.4991C36.8472 16.9752 37.5825 19.3853 37.5825 23.1604H36.4959C36.4959 19.5105 35.7824 17.3406 34.9583 16.1081Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98333 10.6763H20.7709C21.5787 10.6763 22.2331 11.3347 22.2331 12.1385V29.1401H14.3927C14.1181 30.764 12.7043 32 11.0078 32C9.31123 32 7.89746 30.7599 7.62278 29.1401H3.98333C3.11083 29.1401 2.3999 28.4292 2.3999 27.5567V20.9342H9.09809C9.75629 22.0683 10.9699 22.8402 12.3738 22.8402C13.7777 22.8402 14.9914 22.0683 15.6515 20.9342H12.3738V17.122H15.6515C14.9914 15.9879 13.7777 15.216 12.3738 15.216C10.9699 15.216 9.75629 15.9879 9.09619 17.122H2.3999V12.2597C2.3999 11.3872 3.11083 10.6763 3.98333 10.6763ZM9.19005 28.5625C9.19005 29.5643 10.006 30.3802 11.0078 30.3802C12.0095 30.3802 12.8255 29.5643 12.8255 28.5625V28.5423C12.8133 27.5527 11.9974 26.7448 11.0078 26.7448C10.0181 26.7448 9.20217 27.5527 9.19005 28.5423V28.5585V28.5625Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicTruck);
export default __webpack_public_path__ + "static/media/MECHANIC_TRUCK.c8e34eecb12f548a7bb165a1fdf22cfd.svg";
export { ForwardRef as ReactComponent };